
import type { NewsCategory, News, Notice, Protocol } from '@xianlaibang/shared/types'

export const newsApi = {
  // 获取平台资讯列表
  getNews: async (query: Record<string, any>) => {
    const { get } = useHttp()
    return get<null, News>('/system/news/platform', query)
  },
  // 获取平台协议列表
  getProtocol: async () => {
    const { get } = useHttp()
    return get<Protocol[]>('/system/protocol/info')
  },
  // 获取公告列表
  getNotice: async (query: Record<string, any>) => {
    const { get } = useHttp()
    return get<null, Notice>('/system/notice/info', query)
  }
}


// SSR 场景获取平台内容分类
export function useNewsCategory() {
  return useRequest<NewsCategory[]>('/system/contentCategory/platform')
}

// SSR 场景获取平台资讯列表
export function useNews(query: Record<string, any>) {
  return useRequest<null, News>('/system/news/platform', { query })
}

// SSR 场景获取平台资讯详情
export function useNewsDetail(id: number) {
  return useRequest<News>(`/system/news/platform/${id}`)
}

// SSP 场景获取平台资讯上下篇
export function useRelated(id: number) {
  return useRequest<News[]>(`/system/news/platform/near/${id}`)
}
